var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3125 3.88889L10.7164 12.6581C10.6917 13.0225 10.5365 13.3636 10.282 13.6126C10.0275 13.8616 9.69265 14 9.34488 14H3.65512C3.30735 14 2.97248 13.8616 2.71798 13.6126C2.46348 13.3636 2.30825 13.0225 2.28356 12.6581L1.6875 3.88889M5.125 6.77778V11.1111M7.875 6.77778V11.1111M8.5625 3.88889V1.72222C8.5625 1.53068 8.49007 1.34698 8.36114 1.21153C8.2322 1.07609 8.05734 1 7.875 1H5.125C4.94266 1 4.7678 1.07609 4.63886 1.21153C4.50993 1.34698 4.4375 1.53068 4.4375 1.72222V3.88889M1 3.88889H12",
    stroke: "#F87171",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.155193b025fdf16497a33b9b704618bf.svg";
export { ForwardRef as ReactComponent };